import "./style.less";

export default function BookingInfoController(
    user, // resolved
    ENV,
    $scope,
    $rootScope,
    $q,
    $location,
    Bookings,
    BookingPeriods,
    CheckoutErrors,
    Basket,
    Users,
    Roles
) {
    $scope.debug = false;
    $scope.displayPage = false;

    $scope.paymentGatewayEnabled = ENV.payment.enabled;

    /**
     * accept terms
     */
    $scope.mustApproveDialog = false;
    $scope.termAccepted = false;

    $scope.bookingError = { error: false };

    // NEED TO BE REFACTORED,
    // this check is skipped (PTV).
    // $scope.paymentReadyValidationByApi = false; // will be set in dibs-form.js.

    // $scope.user = userService.user;
    $scope.formHolder = {}; // Obj that can contains the child form (must be passed to directive update-user-form)

    const bookingId = ($scope.bookingId = Basket.getBookingId()); // also bind to scope

    if (!bookingId) {
        $scope.bookingError = CheckoutErrors.getBookingError({
            error: true,
            type: "no-booking-id-in-basket",
        });
    }
    /**
     * http://localhost:8080/checkout/payment-complete?currencynumber=208
     * authkey=26ea9c099a7fa3da6a2788f1928a32da
     * amount=15500
     * accepturl=http://localhost:8080/checkout/payment-complete
     * test=1
     * orderid=73823
     * merchant=90234252
     * flexwin_cardlogosize=3
     * statuscode=5
     * approvalcode=123456
     * transact=2897655942 vs 2897646452 (prev order)
     * uniqueoid=yes
     * cardnomask=XXXXXXXXXXXX0000
     * capturenow=yes
     * currency=208
     * md5key=61fc1bd16e003ea7afa2a51814e2d47d
     * callbackurl=https://projektbookbyen.dk/web/api/Booking/HandlePaymentResult/
     * currencyalpha=DKK
     * cardprefix=457110
     * paytype=VISA
     */

    let roles = null;
    $scope.role = null;
    $scope.debug = false;
    $scope.displayForm = false;

    $scope.formHolder = {};

    const allowedRolesDEV = [
        { id: 3, name: "Bruger" },
        {
            id: 4,
            name: "Virksomhed",
        },
        { id: 15, name: "Forening" },
        { id: 72, name: "KK instutition" },
        { id: 82, name: "Ikke-folkeoplysende forening" },
        { id: 83, name: "Friskoler, privatskoler og privatgymnasier" },
    ];

    $scope.changeRolesDEV =
        ENV.type == "development" || ENV.type == "staging"
            ? allowedRolesDEV
            : null;

    $scope.setUserRoleDEV = (roleId) => {
        $scope.models.user.primaryRole = roleId; // TEST

        $scope.models.role = findRole(roleId, roles);

        $scope.formHolder.formUpdateUser.$setDirty();
    };

    const findRole = (userPrimaryRole, roles) => {
        /** lookup user role  */
        return roles.find((role) => role.id === userPrimaryRole);
    };

    const construct = () => {
        $q.all({
            roles: Roles.get(),
            booking: Bookings.get(bookingId),
            bookingPeriods: Bookings.getBookingPeriods(bookingId),
            userCompany: Users.getCompanyInfo(user.id),
            psp: Users.getPsp(user.id),
        }).then(
            (res) => {
                // Check if there is a reserved payment for the current booking
                // - If found go to confirmations page
                const reservedPayment = res.booking.payments.find(
                    (x) => x.statusCode == 202
                );

                if (reservedPayment) {
                    $location
                        .path(`/checkout/payment-complete/`)
                        .search({ paymentid: reservedPayment.paymentID });
                    return;
                }

                $scope.roles = res.roles;

                let bookingPeriods = res.bookingPeriods.filter(
                    (bp) => bp.status == "New"
                );

                if (!bookingPeriods.length) {
                    $scope.bookingError = CheckoutErrors.getBookingError({
                        error: true,
                        type: "booking-expired",
                    });
                    return false;
                }

                $scope.models = {
                    role: findRole(user.primaryRole, res.roles),
                    user: user,
                    company: res.userCompany,
                    psp: res.psp,
                };

                roles = res.roles;

                $scope.displayForm = true;

                /**
                 * Add bookingPeriodEntries to bookingperiods
                 */

                const promises = bookingPeriods.map((bp) => {
                    return BookingPeriods.getEntries(bp.id);
                });

                $q.all(promises).then((res) => {
                    bookingPeriods = bookingPeriods.map((bp, index) => {
                        bp.bookingPeriodEntries = res[index];
                        return bp;
                    });

                    $scope.bookingPeriods = bookingPeriods;

                    $rootScope.$broadcast("booking-update-broadcast");

                    $scope.displayPage = true;
                });
            },
            (err) => {
                console.warn(err);

                $scope.bookingError = CheckoutErrors.getBookingError({
                    error: true,
                    type: "booking-not-found",
                });
            }
        );
    };

    $scope.changeBookingPeriods = () => {
        const lastSearchPeriodsUrl = Basket.getSearchPeriodsUrl();
        const path = lastSearchPeriodsUrl ? lastSearchPeriodsUrl : "/";

        $location.url(path);

        // Bookings.cancelBooking(bookingId).then(
        //     (res) => {
        //         // Basket.removeBookings(); // TO DO - skal kurven tømmes ?
        //         Basket.deleteBookingId();

        //         $location.path("/"); // TO DO - cancel booking redirect where ?
        //     },
        //     (err) => {
        //         // TO DO - cancelBooking when error test (how does data return)
        //         $scope.errorMessage = err.data.message;
        //     }
        // );
    };

    /**
     * SKIP PAYMENT (depends on cap)
     */
    $scope.confirmBooking = (termAccepted) => {
        if (!termAccepted) {
            $scope.mustApproveDialog = true;
        } else {
            if ($scope.formHolder.formUpdateUser.$dirty) {
                updateUserThenProceedToPayment();
            } else {
                proceedToPayment();
            }
        }
    };

    /**
     * PAYMENT
     */
    $scope.checkBookingPaymentExternal = (termAccepted) => {
        if (!termAccepted) {
            $scope.mustApproveDialog = true;
        } else {
            bookingPaymentExternal();
        }
    };

    const bookingPaymentExternal = () => {
        if ($scope.formHolder.formUpdateUser.$dirty) {
            updateUserThenProceedToPayment();
        } else {
            proceedToPayment();
        }
    };

    const updateUserThenProceedToPayment = () => {
        // Update displayname (infotavle)
        let periodsPromises = $scope.bookingPeriods.map((period) => {
            period.note = $scope.models.user.displayName;
            return Bookings.updateBookingPeriod(period);
        });

        $q.all(periodsPromises).then(() => {
            // PrimaryRole 72: kk instutition
            if (
                $scope.models.user.primaryRole == 72 &&
                $scope.formHolder.formUpdateUser.pspElement.$valid
            ) {
                const userPromise = Users.update($scope.models.user);
                const pspPromise = Users.updatePsp(
                    $scope.models.user.id,
                    $scope.models.psp
                );

                $q.all({
                    user: userPromise,
                    psp: pspPromise,
                }).then(
                    () => {
                        proceedToPayment();
                    },
                    (err) => {
                        console.warn(err);
                    }
                );
            } else {
                Users.update($scope.models.user).then(
                    () => {
                        proceedToPayment();
                    },
                    (err) => {
                        $scope.errorMessage =
                            err.status + " : " + err.data.detail;
                    }
                );
            }
        });
    };

    const proceedToPayment = () => {
        // Verify booking
        Bookings.verify($scope.bookingId)
            .then(() => {
                // Skip payment and check
                if (ENV.payment.enabled == false) {
                    return proceedSkipPayment();
                }

                // Check periods before checkout. Create promise array.
                let periodsPromises = $scope.bookingPeriods.map((x) => {
                    return BookingPeriods.checkAvailability(
                        x.start,
                        x.end,
                        x.resourceId,
                        x.bookingId
                    );
                });

                // Run all promises
                $q.all(periodsPromises).then((results) => {
                    const isValid = results.every((x) => x.data.available);
                    if (!isValid) {
                        $scope.bookingError = CheckoutErrors.getBookingError({
                            error: true,
                            type: "booking-not-completed",
                        });
                        return;
                    }

                    // If organization skip card payment and go to reciept
                    if ($scope.models.user.primaryRole == 72) {
                        const updateBookingModel = {
                            userId: $scope.models.user.id,
                            paymentType: 4,
                            note: "",
                            externalNote: "",
                            pspElement: $scope.models.psp.pspElement,
                            responsible: $scope.models.psp.responsible,
                        };

                        return Bookings.update(
                            bookingId,
                            updateBookingModel
                        ).then(() => {
                            proceedSkipPayment();
                        });
                    }

                    // OPEN EXTERNAL PAYMENT. (DIBS/NETS component )
                    $scope.$broadcast("payment-now-broadcast");
                });
            })
            .catch(() => {
                $scope.bookingError = CheckoutErrors.getBookingError({
                    error: true,
                    type: "booking-invalid-prices",
                });

                return;
            });
    };

    const proceedSkipPayment = () => {
        Bookings.completeBooking(bookingId).then(() => {
            $location.path("/checkout/booking-complete");
        });
    };

    $scope.userHasOneOfThesesRoles = (ids, roleId) => {
        return Roles.userHasOneOfThesesRoles(ids, roleId); // returns bool
    };

    construct();
}
